import React from 'react';
import { Alert, Button, Stack, Typography } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { useTranslation } from 'react-i18next';
import useAuthStore from 'stores/authStore';
import useRole from 'hooks/useRole';

const SUPPORT_EMAIL = 'support@evolveanalytics.io';

export function ContactSupportButton({ type = 'directSql' }) {
  const { t } = useTranslation();
  const { isAdmin } = useRole();
  const user = useAuthStore((state) => state.user);
  const membership = useAuthStore((state) => state.activeMembership);
  if (!isAdmin) return null;
  // Only the active workspace and current account enter the user-reviewed draft.
  // Never copy tokens, connection secrets, query strings or other memberships.
  const subject = t(`connections.support.subjects.${type}`);
  const body = t('connections.support.body', {
    request: subject,
    workspace: membership?.tenant?.name || '—',
    workspaceId: membership?.tenant?.public_id || '—',
    email: user?.email || '—',
    role: t(`connections.support.roles.${membership?.role}`),
    page: `${window.location.origin}/console/connections`,
    interpolation: { escapeValue: false },
  });
  const href = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  return <Button component="a" href={href} variant="outlined" size="small" startIcon={<MailOutlineIcon />} sx={{ alignSelf: 'flex-start' }}>{t('connections.support.contact')}</Button>;
}

export function ConnectionUnavailable({ type = 'directSql', sx }) {
  const { t } = useTranslation();
  const { isAdmin } = useRole();
  return <Alert severity="info" sx={sx}>
    <Stack spacing={1.5}>
      <Typography variant="body2">{t(`connections.support.unavailable.${type}`)}</Typography>
      {isAdmin ? <ContactSupportButton type={type} /> : <Typography variant="body2">{t('connections.support.askAdmin')}</Typography>}
    </Stack>
  </Alert>;
}
